import { connect } from "react-redux";
import GroupEventLayout from "../../components/group-event/GroupEventLayout";
import { isLoaded, isLoading } from "../../redux/action/loading";
import {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
} from "../../redux/action/confirm";
import { useRouter } from "next/router";

const GroupPurchasePage = ({
  siteConfig,
  isLoaded,
  isLoading,
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
}) => {
  const router = useRouter();

  return (
    <>
      <GroupEventLayout
        parent={"홈"}
        subChild={"공동 구매"}
        code={siteConfig?.Purchase}
      />
    </>
  );
};
const mapDispatchToProps = {
  isLoading,
  isLoaded,
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
};
export default connect(null, mapDispatchToProps)(GroupPurchasePage);
